import Slide from '@mui/material/Slide';
import { Mui } from '@osu/react-ui';
import { createContext, useState } from 'react';

// @ts-ignore
export const AlertContext = createContext();

// write an alert provider to be placed in index.js as a provider
const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);
  const [open, setOpen] = useState(false);

  const showAlert = (message, severity) => {
    setAlert({ message, severity });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <Mui.Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        onClose={handleClose}
        TransitionComponent={Slide}
      >
        <Mui.Alert
          onClose={handleClose}
          role="alert"
          severity={alert?.severity}
          style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}
        >
          {alert?.message}
        </Mui.Alert>
      </Mui.Snackbar>
    </AlertContext.Provider>
  );
};

export default AlertProvider;